import React from "react";
import "../styles/Welcome.css";
import HeroVideo from "./HeroVideo";
import { useAtom } from "jotai";
import { isMobileAtom } from "../store/atoms/uiAtoms";
import { useAuth } from "../hooks/state";
import { useRegistrationActions } from "../hooks/actions/useRegistrationActions";

const WelcomeScreen = ({ setOverlayContent, setIsRegistering, toggleMenu }) => {
  const [isMobile] = useAtom(isMobileAtom);
  const { createDemoAccount } = useRegistrationActions();
  const { setError, setPassword, setSuccessMessage } = useAuth();

  return (
    <>
      <div className="welcome-text">
        <HeroVideo />
        <hr></hr>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "0px",
            maxWidth: "900px",
            margin: "40px auto",
            textAlign: "center",
          }}
        >
          <h1>
            PriorityPop brings clarity and momentum to visual thinkers and busy
            minds
          </h1>

          <div className="highlights-list">
            <div className="highlight-item">
              <img src="/media/bubble_teal.png" alt="" />
              <p>
                Easy Prioritization – at a glance, without sifting through
                endless rows.
              </p>
            </div>
            <div className="highlight-item">
              <img src="/media/bubble_green.png" alt="" />
              <p>
                Highly Intuitive – visuals separate effort, impact, category,
                and deadline better than lists.
              </p>
            </div>
            <div className="highlight-item">
              <img src="/media/bubble_olive.png" alt="" />
              <p>
                Fun & Dynamic – pop completed tasks, reshuffle your slate, and
                reward progress.
              </p>
            </div>
          </div>
        </div>

        <div style={{ width: "100%", marginTop: "60px" }}>
          <h2
            onClick={() => {
              setIsRegistering(true);
              toggleMenu();
            }}
          >
            Turn Priorities Into Progress With PriorityPop
          </h2>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              textAlign: "left",
              lineHeight: "1.5",
              maxWidth: "600px",
              margin: "20px auto",
              paddingTop: "0px",
              paddingBottom: "20px",
            }}
          >
            Balance effort and impact with a task management system designed for
            real-world priorities. Focus on what truly matters.
          </div>
        </div>

        <button
          style={{ marginTop: "20px", marginBottom: "40px" }}
          onClick={(e) =>
            createDemoAccount(e, {
              isMobile,
              setError,
              setPassword,
              setSuccessMessage,
              setIsRegistering,
            })
          }
        >
          TRY THE FREE DEMO
          {!isMobile && (
            <>
              <br />
              NO CREDIT CARD REQUIRED
            </>
          )}
        </button>
        <section className="founder-quote" aria-label="Why I built PriorityPop">
          <p className="founder-quote-heading">From the founder</p>
          <blockquote>
            “After working with countless amazing individuals across many small
            businesses, I kept seeing the same pattern: they struggled with
            prioritization. People naturally cleared the smallest or most
            comfortable tasks first, while the high-impact work stayed buried.
            They were getting things knocked off their to-do lists, but not
            delivering to their highest potential. As I explored this, I kept
            hearing that neurodivergent people and those with ADHD could really
            use a tool that visually mapped their tasks. That’s when I set out
            on this journey to make something new, and PriorityPop was born.”
          </blockquote>
          <p className="founder-quote-signoff">- Barry Hansen, Founder</p>
        </section>
        <button
          style={{ marginTop: "0px", marginBottom: "40px" }}
          onClick={() => {
            setIsRegistering(true);
            toggleMenu();
          }}
        >
          REGISTER TO START POPPING TODAY
        </button>
      </div>
      <footer
        style={{
          backgroundColor: "#e2f5ff", // light blue
          padding: "20px",
          marginTop: "40px",
          textAlign: "center",
          fontSize: "0.9rem",
        }}
      >
        <div style={{ marginBottom: "12px" }}>
          <a
            href="https://www.facebook.com/profile.php?id=61576789094604"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: "0 12px",
              color: "#0d80b8",
              textDecoration: "none",
            }}
          >
            Facebook
          </a>
          <a
            href="https://www.instagram.com/priority.pop"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: "0 12px",
              color: "#0d80b8",
              textDecoration: "none",
            }}
          >
            Instagram
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOverlayContent("privacy");
            }}
            style={{
              margin: "0 12px",
              color: "#0d80b8",
              textDecoration: "none",
            }}
          >
            {isMobile ? "Privacy" : "Privacy Policy"}
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOverlayContent("terms");
            }}
            style={{
              margin: "0 12px",
              color: "#0d80b8",
              textDecoration: "none",
            }}
          >
            {isMobile ? "Terms" : "Terms & Conditions"}
          </a>
        </div>
        <div style={{ color: "#0e3d4f" }}>
          © {new Date().getFullYear()} PriorityPop. All rights reserved.
        </div>
      </footer>
    </>
  );
};

export default WelcomeScreen;
